<template>
  <div
    class="fixed top-0 left-0 z-50 mt-2 sm:mt-3 ml-2 sm:ml-4"
    :class="{ 'text-white': light && !menuVisible }"
  >
    <RouterLink :to="{ name: 'home' }" class="block px-4 py-4"
      ><AppLogo class="h-4 md:h-5 lg:h-6 fill-current"
    /></RouterLink>
  </div>
  <div
    class="fixed bottom-0 md:bottom-auto md:top-0 right-1/2 md:right-0 mt-2 mb-4 z-50 -mr-10 md:ml-4 md:mr-4"
    :class="{ 'text-white': light && !menuVisible }"
  >
    <button class="w-20 h-16 p-4 focus:outline-none" @click="toggleMenu">
      <div class="relative">
        <div
          class="absolute h-2px w-full bg-current transform transition-transform duration-200"
          :class="menuVisible ? '-rotate-45' : 'translate-y-1'"
        />
        <div
          class="absolute h-2px w-full bg-current transform transition-transform duration-200"
          :class="menuVisible ? 'rotate-45' : '-translate-y-1'"
        />
      </div>
    </button>
  </div>
  <transition name="menu">
    <div
      v-if="menuVisible"
      class="fixed flex flex-col flex-shrink-0 w-full z-40 py-24"
      :class="[
        menuVisible ? 'bg-white inset-0' : 'top-0 left-0',
        { 'text-white': light && !menuVisible },
      ]"
    >
      <div class="flex flex-grow justify-center items-center">
        <div
          class="text-2xl lg:text-3xl text-center uppercase space-y-12 md:space-y-0 md:space-x-12 tracking-super flex flex-col md:flex-row"
        >
          <RouterLink :to="{ name: 'home' }">Stories</RouterLink>
          <!-- <RouterLink :to="{ name: 'stories' }">Archive</RouterLink> -->
          <RouterLink :to="{ name: 'about' }">About</RouterLink>
          <RouterLink :to="{ name: 'newsletter' }">Subscribe</RouterLink>
        </div>
      </div>
      <div
        class="flex justify-center items-center flex-shrink-0 uppercase tracking-super"
      >
        <a href="http://emalin.co.uk" class="relative group"
          ><span class="link-dot-absolute" /> emalin.co.uk</a
        >
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useStore } from '@/store';
import AppLogo from '@/components/AppLogo.vue';

export default defineComponent({
  components: {
    AppLogo,
  },
  setup() {
    const store = useStore();
    const menuVisible = computed(() => store.state.navActive);
    const light = computed(() => store.state.navLight || store.state.navActive);
    const toggleMenu = () => {
      if (menuVisible.value) {
        store.commit.setNavActive(false);
        document.body.style.overflow = '';
      } else {
        store.commit.setNavActive(true);
        document.body.style.overflow = 'hidden';
      }
    };

    return { light, menuVisible, toggleMenu };
  },
});
</script>
